import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { PlacemarkCircle, PlacemarkPin, useYamsContext } from '@fttb/common';
import PropTypes from 'prop-types';
import { getIconImageHrefPin } from "../../../../store/blocks/checkAddress/selectors";
import { getCheckAddressBoundedBy, getCheckAddressGeometry, getRenderTooltip } from "../../../../store/checkAddress/selectors";
var _AddressHousePoint = function _AddressHousePoint(_ref) {
  var boundedBy = _ref.boundedBy,
    children = _ref.children,
    geometry = _ref.geometry,
    iconImageHrefPin = _ref.iconImageHrefPin,
    renderPin = _ref.renderPin;
  var _useYamsContext = useYamsContext(),
    setBounds = _useYamsContext.setBounds;
  useEffect(function () {
    setBounds(boundedBy);
  }, [setBounds, boundedBy]);
  return /*#__PURE__*/React.createElement(PlacemarkCircle, {
    geometry: geometry,
    radius: 8,
    "data-t-id": "components-AddressHousePoint"
  }, renderPin && /*#__PURE__*/React.createElement(PlacemarkPin, {
    geometry: geometry,
    iconImageHref: iconImageHrefPin
  }), children);
};
_AddressHousePoint.propTypes = process.env.NODE_ENV !== "production" ? {
  boundedBy: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  geometry: PropTypes.arrayOf(PropTypes.number),
  renderPin: PropTypes.bool
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    boundedBy: getCheckAddressBoundedBy(state),
    geometry: getCheckAddressGeometry(state),
    iconImageHrefPin: getIconImageHrefPin(state),
    renderPin: !getRenderTooltip(state),
    shouldRender: !!getCheckAddressGeometry(state)
  };
};
export var AddressHousePoint = compose(connect(mapStateToProps), withRenderFlag)(_AddressHousePoint);